export default __webpack_public_path__ + "static/media/FR_Icon.731f41bb.svg";